import * as yup from 'yup'

const viewSettingSchema = yup.object().shape({
    service_configoptions: yup.array().of(
        yup.object().shape({
            name: yup.string().required(),
        })
    ),
})

export default viewSettingSchema
